import { render, staticRenderFns } from "./ProductSpecsElementCreate.vue?vue&type=template&id=c573a202"
import script from "./ProductSpecsElementCreate.vue?vue&type=script&lang=js"
export * from "./ProductSpecsElementCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports